import { getDatapointTime } from './timeseries.js';
import { DataPointDates } from '../components/displays/shared/types.js';
import {
  TimeseriesSlotProps,
  TimeseriesPerVariant,
  TimeseriesBarSlotProps,
} from '../types/timeseries.js';

interface XAxisRange {
  min: number;
  max: number;
}

function buildAxisBarRange(series: TimeseriesBarSlotProps[]) {
  const xRanges: XAxisRange = {
    min: Infinity,
    max: -Infinity,
  };

  series.forEach((singleSeries) => {
    for (const datapoint of singleSeries.datapoints) {
      const startTimestamp = datapoint.start.getTime();
      const endTimestamp = datapoint.end && datapoint.end.getTime();

      if (startTimestamp < xRanges.min) {
        xRanges.min = startTimestamp;
      }

      if (endTimestamp) {
        xRanges.max = Math.max(endTimestamp, xRanges.max);
      } else {
        xRanges.max = Math.max(startTimestamp, xRanges.max);
      }
    }
  });

  return xRanges;
}

function buildAxisRange(series: TimeseriesSlotProps[]) {
  const xRanges: XAxisRange = {
    min: Infinity,
    max: -Infinity,
  };

  series.forEach((singleSeries) => {
    for (const datapoint of singleSeries.datapoints) {
      const { start, end, center } = datapoint as DataPointDates;
      const timestamp = getDatapointTime(start, end, center);
      if (timestamp < xRanges.min) {
        xRanges.min = timestamp;
      }
      if (timestamp > xRanges.max) {
        xRanges.max = timestamp;
      }
    }
  });

  return xRanges;
}
/**
 * Extract the xAxisMin and the xAxisMax of a given timeseries in a given chartVariant.
 *
 * @param series - given TimeseriesPerVariant
 * @returns - the minimum and maximum timestamp or x-axis value of a series
 */
export function getXAxisRange(series: TimeseriesPerVariant): XAxisRange {
  const xRangesPerVariant: XAxisRange[] = [];
  for (const variant of series.shapePriority) {
    const isBar = variant === 'bar';
    if (isBar) {
      xRangesPerVariant.push(buildAxisBarRange(series[variant]));
    } else {
      xRangesPerVariant.push(buildAxisRange(series[variant]));
    }
  }

  return xRangesPerVariant.reduce(
    (prev, current) => ({
      min: Math.min(current.min, prev.min),
      max: Math.max(current.max, prev.max),
    }),
    { min: Infinity, max: -Infinity },
  );
}
